import * as React from 'react';
import { connect } from "react-redux";
import ReactHtmlParser from 'react-html-parser';

import { UserService } from '@fnv-core/authentication';
import { Api } from '@fnv-core/http';
import { Tokenizer } from '@fnv-core/tokens';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { MIJNFNV_LIDZOEKEN_STORECONSENT_URL } from '../../constants/Constants';
import { IFormConfig } from '../../interfaces/FormConfig';
import { KenticoFormContainer } from '../../containers/KenticoFormContainer';
import { MijnFnvLink } from '../pages/interfaces/PageInterfaces';
import { MijnFNVHandigeLinks } from './MijnFNVHandigeLinks';
import { setConsentLidZoeken, clearLidZoeken } from '../../actions/LidZoekenActions';
import { ReactFormHelpers } from '../../containers/helpers/FormHelpers';
import { LidZoekenResultaatHelpers } from '../pages/helpers/LidZoekenResultaatHelpers';
import { FormikProps } from 'formik';
import { BooleanUtil } from '@fnv-core/utils/BooleanUtil';

export interface MijnFNVLidZoekenResultsProps {
    lidZoeken: any;
    formConfig: IFormConfig;
    formDefinitions?: any;
    formName: string;
    pageType: string;
    links: MijnFnvLink[];
    memberFoundText: string;
    memberFoundPluralText: string;
    memberNotFoundText: string;
    memberNotFoundExplanation: string;
    moreThenMaxResultsFoundText: string;
    forms: any;

    setConsentLidZoeken: (id: string, consent: boolean) => void;
    clearLidZoeken: () => void;
}

const mapStateToProps = (state : any) => {
    return {
        lidZoeken: state.lidZoeken,
        forms: state.forms
    };
  };

  const mapDispatchToProps = (dispatch: any) => {
    return {
        clearLidZoeken : () => {
            dispatch(clearLidZoeken());
        },
        setConsentLidZoeken: (id: string, consent: boolean) => {
            dispatch(setConsentLidZoeken(id, consent));
      }
    };
  };

export interface MijnFNVLidZoekenResultsState {
    formLinkBlocks : string[];
}

export class MijnFNVLidZoekenResultsContained extends React.Component<MijnFNVLidZoekenResultsProps, MijnFNVLidZoekenResultsState> {
    state = {
        formLinkBlocks : []
    };

    componentDidMount() {        
        if (this.props.lidZoeken) {
            const formLinkBlocks = {...this.state.formLinkBlocks};
            this.props.lidZoeken.results.map((result, index) => {
                formLinkBlocks[this.props.formName + "-" + index] = !!result["LidgaatAkkoord"];
            });
            this.setState({formLinkBlocks: formLinkBlocks});
        }
    }    

    isHidden = (el) => {
        var style = window.getComputedStyle(el);
        return (style.display === 'none');
    }

    scrollToLinks = (index) => {
        let menuHeight = $(".main-navbar--mijn-fnv").height();
        $("html, body").animate({
            scrollTop: $(".lidzoeken-result__links" + index).offset().top - menuHeight
        }, 500);
    }

    scrollToLinkBlockOnMobile = (index) => {
        const deviceXS = document.getElementsByClassName("device-xs");
        const deviceSM = document.getElementsByClassName("device-sm");

        if (deviceXS.length > 0) {
            if (!this.isHidden(deviceXS[0])) {
                this.scrollToLinks(index);
            }
        }

        if (deviceSM.length > 0) {
            if (!this.isHidden(deviceXS[0])) {
                this.scrollToLinks(index);
            }
        }
    }

    triggerLinksBlock = (values: any, index: number, formikBag: FormikProps<any>) => {
        const formLinkBlocks = {...this.state.formLinkBlocks};

        formLinkBlocks[this.props.formName + "-" + index] = BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"]);
        if (values["PersoonsId"] !== undefined) {
            this.props.setConsentLidZoeken(values["PersoonsId"], BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"]));

            const postUrl = MIJNFNV_LIDZOEKEN_STORECONSENT_URL + '/' + values["PersoonsId"];
            const data = {
              Consent: BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"]),
              Invoeromgeving: UserService.getCurrentRole() 
            };
            Api.put(postUrl, data).then(() => {});
        } else {
          let field: string = null;
          if (!!values['FormGuid']) {
            field = 'FormGuid';
          } else if (!!values['EmailLead']) {
            field = 'EmailLead';
          } else if (!!values['EmailPersoon']) {
            field = 'EmailPersoon';
          }

          if (field) {
            let postUrl = this.props.formConfig.postUrl;
            postUrl = Tokenizer.replaceTokens(postUrl, [values[field]]);
            this.props.setConsentLidZoeken(values[field], BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"]));
            const data = ReactFormHelpers.createFormData(formikBag.values);
            // Use 'fetch' because it is send as FormData, not as json
            fetch(postUrl, {
              method: 'put',
              body: data,
            });
          }
        }

        this.setState({formLinkBlocks: formLinkBlocks}, () => {
            if (formikBag) {                
                formikBag.setFieldValue("LidgaatAkkoord", BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"]));
            }

            if (BooleanUtil.ensureBoolValue(values["LidgaatAkkoord"])) {
                this.scrollToLinkBlockOnMobile(index);
            }
        });
    }

    render () {

        return <>

            {this.props.lidZoeken !== undefined && !!this.props.lidZoeken.isSearchInitialised &&
              this.props.lidZoeken.results.length > 1 && <h2 className="lidzoeken-result__title">{this.props.memberFoundPluralText.replace("{0}", this.props.lidZoeken.totalAmountOfResults)}</h2>
            }
            {this.props.lidZoeken !== undefined && !!this.props.lidZoeken.isSearchInitialised &&
              this.props.lidZoeken.results.length == 1 && <h2 className="lidzoeken-result__title">{this.props.memberFoundText.replace("{0}", this.props.lidZoeken.results.length)}</h2>
            }

            {this.props.moreThenMaxResultsFoundText && this.props.moreThenMaxResultsFoundText !== "" && this.props.lidZoeken.results.length >= 10 && 
                <h3 className="lidzoeken-result__sub-title">{this.props.moreThenMaxResultsFoundText}</h3>}

            {this.props.lidZoeken !== undefined && !!this.props.lidZoeken.isSearchInitialised && 
             this.props.lidZoeken.results.map((result, index) => {
                let isShowLinks = false;

                const formConfig = { ...this.props.formConfig };
                formConfig.index = index;
                formConfig.actions = { 
                    'triggerLinksBlock': (values: any, formikBag: FormikProps<any>) => {
                        this.triggerLinksBlock(values, index, formikBag);     
                    }
                };

                formConfig.handlers = [...LidZoekenResultaatHelpers.getProcesses(formConfig)];

                isShowLinks = result["LidgaatAkkoord"] || false;
                const formDefinitions = { ...this.props.formDefinitions };
                let initialData = result.result ? {...result.result} : {...result};

                if (formConfig && formConfig.receiveFieldsViaGlobalState) {
                    formConfig.receiveFieldsViaGlobalState.map((passThroughFieldName) => {
                        if (this.props.lidZoeken.additionalFormData[passThroughFieldName]) {                            
                            initialData[passThroughFieldName] = this.props.lidZoeken.additionalFormData[passThroughFieldName];
                        }
                    });
                }

                return <React.Fragment key={"lidzoeken-" + index}>
                    <div className="row lidzoeken-result__row">
                        <div className="col-12 col-md-8">
                            {this.props.formDefinitions !== undefined && <KenticoFormContainer          
                                editMode={true}
                                formConfig={formConfig}
                                formDefinitions={formDefinitions}
                                additionalCssClass={"lidzoeken-result " + this.props.formName + "-result"}
                                withLinkToFormPage={false}
                                formName={this.props.formName + "-" + index}
                                pageType={this.props.pageType}
                                initialData={initialData}
                                onOverrideGetFormValues={
                                    () => { 
                                        return {
                                            "LidgaatAkkoord": result["LidgaatAkkoord"] || false
                                        };
                                    }
                                }
                            />}
                        </div>
                        <div className={"col-12 col-md-4 lidzoeken-result__links lidzoeken-result__links" + index}>
                            {isShowLinks && <MijnFNVHandigeLinks 
                                title={(this.props.formConfig as any).LidZoekenActionsTitle || "Aanpassingen"}
                                MijnFnvLinks={this.props.links} 
                                dataContext={result}></MijnFNVHandigeLinks>}
                        </div>
                    </div>
                </React.Fragment>;
            })}

            {this.props.lidZoeken !== undefined && !this.props.lidZoeken.isSearching &&
             !!this.props.lidZoeken.isSearchInitialised && 
             this.props.lidZoeken.results.length == 0 && <React.Fragment>
                    <div className="row">
                        <div className="col-12 lidzoeken-result__no-results">
                            <div className="content__hr"></div>
                            <h2>{ReactHtmlParser(this.props.memberNotFoundText)}</h2>
                            {ReactHtmlParser(this.props.memberNotFoundExplanation)}
                            <div className="content__hr"></div>
                        </div>
                    </div>
                </React.Fragment>
            }

            {this.props.lidZoeken !== undefined && !!this.props.lidZoeken.isSearching &&
             !!this.props.lidZoeken.isSearchInitialised &&         
                <React.Fragment>
                    <div className="spin-animation spinning-icon"></div>
                </React.Fragment>
            }
        </>;
    }
}

MijnFNVLidZoekenResultsContained.contextType = MijnFNVPageContext;

export const MijnFNVLidZoekenResults = connect(mapStateToProps, mapDispatchToProps)(MijnFNVLidZoekenResultsContained);
